module.exports = __webpack_public_path__ + "img/0Q3A3452_L_Wood.ca65b94a.jpg";